export default "__VITE_ASSET__XtcWUS9V__"